'use strict';
var wellKnownSymbol = require('../internals/well-known-symbol');

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/operation-retrier/node_modules/core-js/internals/to-string-tag-support.js
// module id = 1535
// module chunks = 25